import {SideNavInterface} from '../../interfaces/side-nav.type';

export const ROUTES: SideNavInterface[] = [
  {
    path: '/dashboard',
    title: 'Dashboards',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'dashboard',
    submenu: [
      {
        path: '/dashboard',
        title: 'Allgemein',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'dashboard',
        submenu: [],
        routerLinkActiveExact: true
      },
      {
        path: '/dashboard/overdue',
        title: 'Fälligkeiten',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'clock-circle',
        rights: ['duedates.view'],
        submenu: [],
        routerLinkActiveExact: true
      }
    ]
  },
  {
    path: '/objects',
    title: 'Objekte',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'home',
    rights: ['objects.view', 'objects.assigned'],
    submenu: []
  },
  {
    path: '/contacts',
    title: 'Kontakte',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'solution',
    rights: ['contacts.view'],
    submenu: [
      {
        path: '/contacts',
        title: 'Kontakte',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'solution',
        submenu: []
      },
      {
        path: '/residents',
        title: 'Bewohner',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        rights: ['contacts.view'],
        submenu: []
      }
    ]
  },
  {
    path: '/calendar',
    title: 'Kalender & Planung',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'calendar',
    submenu: [
      {
        path: '/tasks',
        title: 'Aufgaben',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'schedule',
        submenu: []
      },
      {
        path: '/wasteplan',
        title: 'Abfuhrpläne',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'delete',
        rights: ['wasteplans.view'],
        submenu: []
      },
/*      {
        path: '/maintenance',
        title: 'Wartungen',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'audit',
        submenu: [],
        rights: ['maintenance.view'],
        moduleName: 'MAINTENANCE',
      },*/
      {
        path: '/absence',
        title: 'Abwesenheiten',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user-delete',
        rights: ['absences.view'],
        submenu: []
      },
    ]
  },
  {
    path: '/tickets',
    title: 'Tickets',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'inbox',
    rights: ['tickets.view', 'tickets.assigned'],
    submenu: [
      {
        path: '/tickets',
        routerLinkActiveExact: true,
        title: 'Übersicht',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'inbox',
        submenu: []
      },
      {
        path: '/tickets/public-forms',
        routerLinkActiveExact: true,
        title: 'Formulare',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'form',
        submenu: []
      }, {
        path: '/tickets/templates',
        routerLinkActiveExact: true,
        title: 'Vorlagen',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'snippets',
        submenu: []
      },
    ]
  },

  {
    path: '/worklogs',
    title: 'Arbeitsprotokolle',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'file-done',
    rights: ['worklogs.view'],
    submenu: [
      {
        path: '/worklogs',
        routerLinkActiveExact: true,
        title: 'Übersicht',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'file-done',
        submenu: []
      },
      {
        path: '/worklogs/templates',
        routerLinkActiveExact: true,
        title: 'Vorlagen',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'snippets',
        rights: ['worklogs.templates'],
        submenu: []
      }
    ]
  },
  {
    path: '/sachanlagen',
    title: 'Sachanlagen',
    iconType: 'lucide',
    iconTheme: 'outline',
    icon: 'box',
    rights: ['assets.view'],
    submenu: [],
    routerLinkActiveExact: true
  },
  {
    path: '/maps',
    title: 'Karten & GPS',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'compass',
    rights: ['maps.view'],
    submenu: [],
  /*  submenu: [
      {
        path: '/maps',
        title: 'Karte',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'compass',
        submenu: []
      },
    ],*/
  },
  {
    path: '/route-planner',
    title: 'Routenplaner',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'node-index',
    rights: ['routes.view'],
    submenu: []
  },
  {
    path: '/servicecatalog',
    title: 'Leistungskataloge',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'book',
    rights: ['servicecatalogs.view'],
    submenu: []
  },

  {
    path: '/counter',
    title: 'Zähler',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'dashboard',
    rights: ['counters.view'],
    submenu: []
  },
  {
    path: '/consumables',
    title: 'Verbrauchsmaterial',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'bulb',
    rights: ['consumables.view', 'consumables.stats'],
    submenu: [
      {
        path: '/consumables/manage',
        title: 'Verwalten',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'profile',
        rights: ['consumables.view'],
        submenu: []
      },
      {
        path: '/consumables/stats',
        title: 'Auswertung',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'line-chart',
        rights: ['consumables.stats'],
        submenu: []
      }
    ],
  },
  {
    path: '/news',
    title: 'News',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'mail',
    rights: ['news.view'],
    submenu: [
      {
        path: '/news',
        title: 'Bewohner-News',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'mail',
        submenu: []
      },
      {
        path: '/employee-news',
        title: 'Ankündigungen',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'team',
        submenu: []
      }
    ],
  },
  {
    path: '/users',
    title: 'Personal',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'team',
    submenu: [
      {
        path: '/users',
        title: 'Mitarbeiter',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        rights: ['users.view'],
        submenu: [],
        allowIfExpired: true
      },
      {
        path: '/team',
        title: 'Teams',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'team',
        rights: ['users.teams'],
        submenu: []
      },
      {
        path: '/timetracking',
        title: 'Zeiterfassung',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'clock-circle',
        rights: ['timetracking.view'],
        submenu: []
      },
      {
        path: '/user-object-permission',
        title: 'Berechtigungssystem',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'security-scan',
        rights: ['users.edit'],
        submenu: [],
        permissionSystem: true
      }
    ],
    allowIfExpired: true
  },
  {
    path: '/company',
    title: 'Mein Unternehmen',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'shop',
    submenu: [],
    adminOnly: true,
    allowIfExpired: true
  }
];
